"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = exports.getFilenameFromURL = exports.fileSizeReadable = exports.fileExtension = exports.countUnread = exports.cheksWhatsApp = exports.addTarget = void 0;
exports.getOuterWidth = getOuterWidth;
exports.urlFormatHelper = exports.updateArrayImmutably = exports.removeFromObjectImmutably = exports.mimeTypeLeft = exports.linkify = exports.linebreaks = exports.isValidURL = exports.isValidMail = exports.isValidDate = exports.isUnsafeFile = exports.isUnattended = exports.isNotFileAllowed = exports.isNewMedia2 = exports.isNewMedia = exports.isLocalServer = exports.isImageURL = exports.isImageType = exports.isChatStarted = exports.hasUnread = exports.groupImages = void 0;
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var linkify = exports.linkify = function linkify(text) {
  var urlRegex = /(\b(?:(?:https?|ftp|file):\/\/|www\.)[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  return text.split(urlRegex).map(function (e, i) {
    return urlRegex.test(e) ? /*#__PURE__*/_react["default"].createElement("a", {
      key: i,
      target: "_blank",
      rel: "noopener noreferrer",
      href: e.startsWith('www') ? 'http://' + e : e
    }, e) : e;
  });
};
var splitBreaks = function splitBreaks(text) {
  var lines = [];
  text.split('\n').map(function (t, i) {
    return lines.push.apply(lines, [t, /*#__PURE__*/_react["default"].createElement("br", {
      key: i
    })]);
  });
  return lines;
};
var linebreaks = exports.linebreaks = function linebreaks(texts) {
  var newtexts = [];
  texts.map(function (text) {
    return typeof text === 'string' && text.includes('\n') ? newtexts.push.apply(newtexts, _toConsumableArray(splitBreaks(text))) : newtexts.push(text);
  });
  return newtexts;
};
var onImageClick = function onImageClick(e, onClick) {
  return onClick ? onClick(Number(e.currentTarget.id)) : undefined;
};
var groupImages = exports.groupImages = function groupImages(arr, _onClick) {
  if (arr.length <= 2) return arr.map(function (image, i) {
    return /*#__PURE__*/_react["default"].createElement("img", {
      key: i,
      id: i,
      src: image,
      alt: 'image' + i,
      onClick: function onClick(e) {
        return onImageClick(e, _onClick);
      }
    });
  });else if (arr.length === 3) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", {
    id: 0,
    src: arr[0],
    alt: "image0",
    onClick: function onClick(e) {
      return onImageClick(e, _onClick);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    id: 1,
    src: arr[1],
    alt: "image1",
    onClick: function onClick(e) {
      return onImageClick(e, _onClick);
    }
  }), /*#__PURE__*/_react["default"].createElement("img", {
    id: 2,
    src: arr[2],
    alt: "image2",
    onClick: function onClick(e) {
      return onImageClick(e, _onClick);
    }
  })));else return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    id: 0,
    src: arr[0],
    alt: "image0",
    onClick: function onClick(e) {
      return onImageClick(e, _onClick);
    }
  }), /*#__PURE__*/_react["default"].createElement("img", {
    id: 2,
    src: arr[2],
    alt: "image2",
    onClick: function onClick(e) {
      return onImageClick(e, _onClick);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    id: 1,
    src: arr[1],
    alt: "image1",
    onClick: function onClick(e) {
      return onImageClick(e, _onClick);
    }
  }), /*#__PURE__*/_react["default"].createElement("img", {
    id: 3,
    src: arr[3],
    alt: "image3",
    onClick: function onClick(e) {
      return onImageClick(e, _onClick);
    }
  }), arr.length >= 5 && /*#__PURE__*/_react["default"].createElement("span", {
    onClick: _onClick ? function () {
      return _onClick(0);
    } : undefined
  }, "+", arr.length - 4)));
};
var countUnread = exports.countUnread = function countUnread(messages) {
  return messages.reduce(function (counter, _ref) {
    var seen = _ref.seen,
      origin = _ref.origin;
    return !seen && origin !== 'AGENT' ? counter + 1 : counter;
  }, 0);
};
var hasUnread = exports.hasUnread = function hasUnread(messages, type, unread) {
  if (isNewMedia(type)) {
    return unread;
  } else {
    return messages.some(function (m) {
      return !m.seen;
    });
  }
};
var isUnattended = exports.isUnattended = function isUnattended(c, active) {
  return !active && c.messages && hasUnread(c.messages, c.type, c.unreadMessage);
};
var isChatStarted = exports.isChatStarted = function isChatStarted(c) {
  if (isNewMedia(c.type)) {
    return c.chatStarted === undefined ? false : c.chatStarted;
  }
  return true;
};
var isNewMedia = exports.isNewMedia = function isNewMedia(type) {
  return type !== 'TWITTER' && type !== 'MAIL' && type !== 'CHAT' && type !== '' && type !== undefined;
};
var isNewMedia2 = exports.isNewMedia2 = function isNewMedia2(type) {
  return type !== 'TWITTER' && type !== 'CHAT' && type !== '' && type !== undefined;
};
var urlFormatHelper = exports.urlFormatHelper = function urlFormatHelper(url, source) {
  var mult = 'WhatsApp';
  var multChat = 'chats';
  if (url.includes(mult) && source === _constants.MSG_SOURCE.USER) {
    var index0 = url.indexOf('WhatsApp');
    var host = window.location.protocol + '//' + (window.location.hostname === 'localhost' ? '192.168.1.30' : window.location.hostname) + '/WhatsAppMedia';
    var subUrl = url.substring(index0 + mult.length);
    subUrl = decodeURIComponent(subUrl);
    var pipeIndex = subUrl.indexOf('|');
    if (pipeIndex !== -1) {
      subUrl = subUrl.substring(0, pipeIndex);
    }
    return host + subUrl;
  } else if (url.includes(multChat)) {
    var _index = url.indexOf('chats');
    var _host = window.location.protocol + '//' + (window.location.hostname === 'localhost' ? '192.168.1.33' : window.location.hostname) + '/chats';
    var _subUrl = url.substring(_index + multChat.length);
    _subUrl = decodeURIComponent(_subUrl);
    var _pipeIndex = _subUrl.indexOf('|');
    if (_pipeIndex !== -1) {
      _subUrl = _subUrl.substring(0, _pipeIndex);
    }
    return _host + _subUrl;
  }
  return url;
};

/* istanbul ignore next */
var updateArrayImmutably = exports.updateArrayImmutably = function updateArrayImmutably(arr, i, value) {
  return Object.assign(_toConsumableArray(arr), _defineProperty({}, i, value));
};
var removeFromObjectImmutably = exports.removeFromObjectImmutably = function removeFromObjectImmutably(key, _ref2) {
  var _ = _ref2[key],
    newObj = _objectWithoutProperties(_ref2, [key].map(_toPropertyKey));
  return newObj;
};
var isValidDate = exports.isValidDate = function isValidDate(date) {
  if (date) {
    if (date instanceof Date) {
      return true;
    } else if (!isNaN(new Date(date))) {
      return true;
    } else {
      return false;
    }
  }
  return false;
};
var mailRegEx = RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]{2,}\.)+[a-zA-Z]{2,}))$/);
var isValidMail = exports.isValidMail = function isValidMail(mail) {
  return mailRegEx.test(mail);
};
var urlRegEx = RegExp(/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/);
var isValidURL = exports.isValidURL = function isValidURL(url) {
  if (urlRegEx.test(url)) {
    try {
      new URL(url);
      return true;
    } catch (_unused) {
      return false;
    }
  }
  return false;
};
var isImageURL = exports.isImageURL = function isImageURL(url) {
  if (!url) return false;
  if (!isValidURL(url)) return false;
  var ext = new URL(url, url.startsWith('/') ? window.location.origin : undefined).pathname.split('.').pop();
  return ['jpg', 'png', 'jpeg', 'gif', 'bmp'].includes(ext);
};
var isImageType = exports.isImageType = function isImageType(file) {
  return file.type.split('/')[0] === 'image';
};
var getFilenameFromURL = exports.getFilenameFromURL = function getFilenameFromURL(url) {
  return isValidURL(url) ? decodeURI(new URL(url).pathname.split('/').pop()) : '';
};
var isUnsafeFile = exports.isUnsafeFile = function isUnsafeFile(file) {
  var ext = file.name.split('.').pop();
  return _constants.UNSAFE_FILE_EXTS.includes(ext);
};
var getLocation = exports.getLocation = function getLocation(contentHtml, hostname, href) {
  var environment = href.split('/')[0];
  hostname = environment + '//' + hostname + '/EmailFiles';
  var res = contentHtml.split('$domain$').join(hostname);
  res = addTarget(res);
  return res;
};
var addTarget = exports.addTarget = function addTarget(contentHtml) {
  var result = contentHtml.split('<a ').join('<a target="_blank"');
  return result;
};
var cheksWhatsApp = exports.cheksWhatsApp = function cheksWhatsApp(status) {
  return status === 'send' || status === 'submitted' ? 'sent-v02' : 'read-v02';
};
function getOuterWidth(el) {
  var style = getComputedStyle(el);
  return el.offsetWidth + (parseInt(style.marginLeft, 10) || 0) + (parseInt(style.marginRight, 10) || 0);
}
var mimeTypeLeft = exports.mimeTypeLeft = function mimeTypeLeft(mime) {
  return mime.split('/')[0];
};
var fileSizeReadable = exports.fileSizeReadable = function fileSizeReadable(size) {
  if (isNaN(size)) {
    return '';
  } else if (size >= 1000000000) {
    return Math.ceil(size / 1000000000) + ' GB';
  } else if (size >= 1000000) {
    return Math.ceil(size / 1000000) + ' MB';
  } else if (size >= 1000) {
    return Math.ceil(size / 1000) + ' kB';
  } else {
    return Math.ceil(size) + ' B';
  }
};
var fileExtension = exports.fileExtension = function fileExtension(file) {
  var extensionSplit = file.split('.');
  if (extensionSplit.length > 1) {
    return extensionSplit[extensionSplit.length - 1];
  } else {
    return 'none';
  }
};
var isLocalServer = exports.isLocalServer = function isLocalServer() {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '';
};
var isNotFileAllowed = exports.isNotFileAllowed = function isNotFileAllowed(file) {
  var ext = file.name.split('.').pop();
  return !['jpg', 'png', 'PNG', 'jpeg', 'gif', 'bmp'].includes(ext);
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/utils/helpers.js
// module id = 53
// module chunks = 0